import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import POServices from "../../../services/PoServices";
import RequestServies from '../../../services/RequestServies';
import Swal from "sweetalert2";

const POEditModal = ({ show, handleClose, item, test, refreshPO }) => {
  const [formData, setFormData] = useState({ supplier: "", items: [], deliveryAddress: {} });
  const [suppliers, setSuppliers] = useState([]);
  const [isAdvanceRental, setIsAdvanceRental] = useState(false);
  const [advanceRentalAmount, setAdvanceRentalAmount] = useState("");
  const [advanceRentalPercent, setAdvanceRentalPercent] = useState("");
  const [advanceRentalError, setAdvanceRentalError] = useState(false);

  // Fetch supplier list
  const fetchSuppliers = async () => {
    try {
      const res = await POServices.activeSuppliers();
      setSuppliers(res?.data || []);
    } catch (err) {
      console.error("Failed to fetch suppliers", err);
    }
  };

  useEffect(() => {
    if (show) {
      fetchSuppliers();

      // Advance Rental values initialize on edit open
      const isAR = item?.poType === "Advance Payment";

      setIsAdvanceRental(isAR);

      setAdvanceRentalAmount(
        isAR
          ? (item?.advanceRentalAmount || item?.advanceRental || 0)
          : ""
      );

      setAdvanceRentalPercent(
        isAR
          ? (item?.advanceRentalPercent || 0)
          : ""
      );

      setAdvanceRentalError(false);
    }
  }, [show, item]);

  // Initialize formData when item changes
  useEffect(() => {
    if (item) {
      setFormData(prev => ({
        ...prev,  // ✅ keep previous state like updated textarea
        subject: item?.subject || "",   // ✅ ADD THIS
        termCondition: item?.termCondition || [],
        supplier: item.items?.[0]?.supplier?._id || "",
        requisitionNo: item?.requisitionNo?.requisitionNo || "",
        deliveryAddress: item?.deliveryAddress || {},

        items: item.items?.map(poItem => ({
          id: poItem._id,
          itemId: poItem.itemId,

          partNo: poItem.partNo,
          description: poItem.description,

          approveQty: poItem.approveQty,
          originalApproveQty: poItem.approveQty,

          unit: poItem.unit,
          unitId: poItem.unitId,

          rate: poItem.rate || 0,
          cgst: poItem.cgst || 0,
          sgst: poItem.sgst || 0,
          igst: poItem.igst || 0,

          // ✅ NEW
          removeThisItem: false,
        })) || [],
      }));
    }
  }, [item]);


  // Handle local input changes
  // REPLACE YOUR handleInputChange FUNCTION WITH THIS COMPLETE VERSION

  const handleInputChange = (idx, field, value) => {
    const newItems = [...formData.items];

    if (field === "cgst") {
      newItems[idx].cgst = value;
      newItems[idx].sgst = value;
      newItems[idx].igst = "0";
    }

    else if (field === "sgst") {
      newItems[idx].sgst = value;
      newItems[idx].cgst = value;
      newItems[idx].igst = "0";
    }

    else if (field === "igst") {
      newItems[idx].igst = value;
      newItems[idx].cgst = "0";
      newItems[idx].sgst = "0";
    }

    // ✅ FIX FOR RATE EDITING
    else if (field === "rate") {
      newItems[idx].rate = value;
    }

    // ✅ FIX FOR DESCRIPTION EDITING
    else if (field === "description") {
      newItems[idx].description = value;
    }

    else if (field === "approveQty") {
      const num = Number(value);
      const max = Number(newItems[idx].originalApproveQty);

      if (num > max) {
        Swal.fire(
          "Invalid Qty",
          `Approved qty cannot be greater than ${max}`,
          "warning"
        );

        newItems[idx].approveQty = max;
      } else {
        newItems[idx].approveQty = value;
      }
    }

    else {
      newItems[idx][field] = value;
    }

    setFormData(prev => ({
      ...prev,
      items: newItems
    }));
  };

  const handleRemoveItemToggle = (
    idx,
    checked
  ) => {

    setFormData((prev) => {

      const remainingItems =
        prev.items.filter(
          (it) => !it.removeThisItem
        );

      // =====================================
      // ✅ PO MUST KEEP AT LEAST ONE ITEM
      // =====================================
      if (
        checked &&
        remainingItems.length <= 1
      ) {

        Swal.fire(
          "Not Allowed",
          "Purchase Order must contain at least one item.",
          "warning"
        );

        return prev;
      }

      return {
        ...prev,

        items: prev.items.map(
          (it, index) =>
            index === idx
              ? {
                ...it,
                removeThisItem: checked
              }
              : it
        )
      };
    });
  };

  // Calculate totals
  const calculateTotals = () => {
    let base = 0;
    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    formData.items.forEach((it) => {

      // =====================================
      // ✅ ITEM MARKED FOR REMOVAL
      // DO NOT INCLUDE IN PO CALCULATION
      // =====================================
      if (it.removeThisItem) {
        return;
      }

      const lineBase =
        (parseFloat(it.rate) || 0) *
        (parseFloat(it.approveQty) || 0);

      base += lineBase;

      cgst +=
        (lineBase *
          (parseFloat(it.cgst) || 0)) /
        100;

      sgst +=
        (lineBase *
          (parseFloat(it.sgst) || 0)) /
        100;

      igst +=
        (lineBase *
          (parseFloat(it.igst) || 0)) /
        100;
    });

    return {
      base: base.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      igst: igst.toFixed(2),

      total: (
        base +
        cgst +
        sgst +
        igst
      ).toFixed(2),
    };
  };

  const handleQtyUpdate = async (it) => {
    try {
      // ===================================
      // Validation
      // ===================================
      if (Number(it.approveQty) <= 0) {
        return Swal.fire(
          "Invalid Qty",
          "Approved qty must be greater than 0.",
          "warning"
        );
      }

      if (Number(it.approveQty) > Number(it.originalApproveQty)) {
        return Swal.fire(
          "Invalid Qty",
          `Approved qty cannot be greater than ${it.originalApproveQty} ${it.unit}.`,
          "warning"
        );
      }

      // ===================================
      // Preview
      // ===================================
      const previewRes = await POServices.updatePOEditQty({
        poId: item._id,
        preview: true,
        items: [
          {
            poItemId: it.id,
            itemId: it.itemId,
            approveQty: Number(it.approveQty),
          },
        ],
      });

      const preview = previewRes?.data[0];

      // ===================================
      // Confirmation
      // ===================================
      const result = await Swal.fire({
        title: "Confirm Quantity Update",
        icon: "question",
        html: `
        <table class="table table-bordered mb-0">
          <tbody>
            <tr>
              <th style="width:40%">PO Qty</th>
              <td>${preview.poQty} ${preview.poUnit}</td>
            </tr>
            <tr>
              <th>Item Qty</th>
              <td>${preview.itemQty} ${preview.itemUnit}</td>
            </tr>
          </tbody>
        </table>

        ${preview.conversionApplied
            ? `<div class="mt-3 text-primary fw-bold">
                Unit conversion will be applied.
              </div>`
            : ""
          }
      `,
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#198754",
      });

      if (!result.isConfirmed) {
        return;
      }

      // ===================================
      // Actual Update
      // ===================================
      await POServices.updatePOEditQty({
        poId: item._id,
        preview: false,
        items: [
          {
            poItemId: it.id,
            itemId: it.itemId,
            approveQty: Number(it.approveQty),
          },
        ],
      });

      // ===================================
      // Refresh Parent & Modal
      // ===================================
      if (refreshPO) {
        await refreshPO(item._id);
      }

      Swal.fire({
        icon: "success",
        title: "Quantity Updated",
        text: "PO and Item quantities updated successfully.",
        timer: 1500,
        showConfirmButton: false,
      });

    } catch (err) {
      Swal.fire(
        "Error",
        err?.response?.data?.message || "Failed to update quantity.",
        "error"
      );
    }
  };


  const handleSubmit = async () => {
    try {

      // ===================================
      // 🔴 ITEM VALIDATION
      // ===================================
      for (let it of formData.items) {

        if (Number(it.approveQty) > Number(it.originalApproveQty)) {
          return Swal.fire(
            "Error",
            `Approved qty for ${it.partNo} cannot exceed ${it.originalApproveQty} ${it.unit}`,
            "error"
          );
        }

        if (Number(it.approveQty) <= 0) {
          return Swal.fire(
            "Error",
            `Approved qty for ${it.partNo} must be greater than 0`,
            "error"
          );
        }
      }

      // ===================================
      // 🔴 ADVANCE RENTAL VALIDATION
      // ===================================
      if (isAdvanceRental) {

        const amount = Number(advanceRentalAmount);
        const percent = Number(advanceRentalPercent);
        const total = Number(calculateTotals().total);

        if (amount <= 0 || percent <= 0) {

          setAdvanceRentalError(true);

          return Swal.fire(
            "Error",
            "Please enter valid Advance Rental Amount / %",
            "error"
          );
        }

        if (amount > total) {
          return Swal.fire(
            "Error",
            "Advance Rental amount cannot exceed Grand Total",
            "error"
          );
        }

        if (percent > 100) {
          return Swal.fire(
            "Error",
            "Advance Rental percentage cannot exceed 100%",
            "error"
          );
        }
      }

      // ===================================
      // ✅ PREPARE PAYLOAD
      // ===================================
      const payload = {

        items: formData.items.map((it) => ({
          id: it.id,
          partNo: it.partNo,
          description: it.description,
          approveQty: it.approveQty,
          rate: it.rate,
          cgst: it.cgst,
          sgst: it.sgst,
          igst: it.igst,
          supplier: formData.supplier,
        })),

        subject: formData.subject,
        termCondition: formData.termCondition,

        poType: isAdvanceRental
          ? "Advance Payment"
          : (item?.poType === "FOC PO"
            ? "FOC PO"
            : "Normal"),

        advanceRentalAmount: isAdvanceRental
          ? Number(advanceRentalAmount || 0)
          : 0,

        advanceRentalPercent: isAdvanceRental
          ? Number(advanceRentalPercent || 0)
          : 0
      };

      // ===================================
      // ✅ UPDATE PO
      // ===================================
      await POServices.updatePO(item._id, payload);

      // ===================================
      // ✅ Refresh Parent + Modal
      // ===================================
      if (refreshPO) {
        await refreshPO(item._id);
      }

      // ===================================
      // ✅ SUCCESS
      // ===================================
      Swal.fire({
        icon: "success",
        title: "Updated",
        text: "Purchase Order updated successfully.",
        timer: 1500,
        showConfirmButton: false,
      });

      handleClose();

    } catch (err) {

      console.error(err);

      Swal.fire(
        "Error",
        err?.response?.data?.message || "Failed to update PO",
        "error"
      );
    }
  };

  const isFOC = item?.poType === "FOC PO";

  const handleAdvanceAmountChange = (value) => {
    setAdvanceRentalError(false);
    setAdvanceRentalAmount(value);

    const total = parseFloat(calculateTotals().total) || 0;
    const amount = parseFloat(value) || 0;

    if (total > 0) {
      setAdvanceRentalPercent(((amount / total) * 100).toFixed(2));
    } else {
      setAdvanceRentalPercent("");
    }
  };

  const handleAdvancePercentChange = (value) => {
    setAdvanceRentalError(false);
    setAdvanceRentalPercent(value);

    const total = parseFloat(calculateTotals().total) || 0;
    const percent = parseFloat(value) || 0;

    if (total > 0) {
      setAdvanceRentalAmount(((total * percent) / 100).toFixed(2));
    } else {
      setAdvanceRentalAmount("");
    }
  };

  useEffect(() => {
    if (!isAdvanceRental) return;

    const total = Number(calculateTotals().total || 0);
    const percent = Number(advanceRentalPercent || 0);

    if (total > 0 && percent > 0) {
      const newAmount = ((total * percent) / 100).toFixed(2);

      setAdvanceRentalAmount(newAmount);
    }
  }, [
    formData.items,
    isAdvanceRental,
    advanceRentalPercent
  ]);

  const remainingItemCount =
    formData.items.filter(
      (it) => !it.removeThisItem
    ).length;

  const selectedRemoveCount =
    formData.items.filter(
      (it) => it.removeThisItem
    ).length;

  const hasSelectedRemoveItems =
    selectedRemoveCount > 0;

const handleRemoveSelectedItems = async () => {
  try {

    // =====================================
    // SELECTED ITEMS FOR REMOVAL
    // =====================================
    const selectedItems =
      formData.items.filter(
        (it) => it.removeThisItem
      );

    if (!selectedItems.length) {
      return Swal.fire(
        "Warning",
        "Please select at least one item.",
        "warning"
      );
    }


    // =====================================
    // SAFETY - AT LEAST ONE ITEM MUST REMAIN
    // =====================================
    const remainingItems =
      formData.items.filter(
        (it) => !it.removeThisItem
      );

    if (!remainingItems.length) {
      return Swal.fire(
        "Not Allowed",
        "Purchase Order must contain at least one item.",
        "warning"
      );
    }


    // =====================================
    // FINAL REMOVE PAYLOAD
    //
    // Backend will:
    // - remove selected rows
    // - calculate PO totals
    // - update totalItems
    // - reopen requisition items
    // - reopen requisition for PO creation
    // =====================================
    const payload = {

      poId:
        item?._id,

      requisitionId:
        item?.requisitionNo?._id,

      items:
        selectedItems.map(
          (it) => ({
            poItemId:
              it.id
          })
        )
    };


    console.log(
      "REMOVE PO ITEM PAYLOAD:",
      payload
    );


    // =====================================
    // CONFIRM BEFORE REMOVE
    // =====================================
    const result =
      await Swal.fire({

        title:
          "Remove Selected Item?",

        html: `
          <div style="text-align:left;">

            <p>
              You are about to remove
              <b>${selectedItems.length}</b>
              item(s) from
              <b>PO ${item?.poNumber || "-"}</b>.
            </p>

            <p class="mb-2">
              <b>After removal:</b>
            </p>

            <ul style="padding-left:20px;">

              <li>
                Selected item(s) will be removed
                from this Purchase Order.
              </li>

              <li>
                Requisition
                <b>${item?.requisitionNo?.requisitionNo || "-"}</b>
                will be reopened for PO creation.
              </li>

              <li>
                Removed requisition item(s)
                will become available again
                for creating a new PO.
              </li>

            </ul>

            <div
              class="mt-3 text-danger fw-bold"
            >
              Do you want to continue?
            </div>

          </div>
        `,

        icon:
          "warning",

        showCancelButton:
          true,

        confirmButtonText:
          "Yes, Remove",

        cancelButtonText:
          "Cancel",

        confirmButtonColor:
          "#dc3545"
      });


    if (!result.isConfirmed) {
      return;
    }


    // =====================================
    // CALL REMOVE API
    // =====================================
    const response =
      await POServices.removePOItems(
        payload
      );


    console.log(
      "REMOVE PO ITEM RESPONSE:",
      response
    );


    // =====================================
    // REFRESH CURRENT PO
    // =====================================
    if (refreshPO) {
      await refreshPO(
        item._id
      );
    }


    // =====================================
    // SUCCESS MESSAGE
    // =====================================
    await Swal.fire({

      icon:
        "success",

      title:
        "Item Removed",

      html: `
        <div>
          <b>${selectedItems.length}</b>
          item(s) removed successfully.
          <br /><br />

          Requisition
          <b>${item?.requisitionNo?.requisitionNo || "-"}</b>
          has been reopened for PO creation.
        </div>
      `,

      timer:
        2200,

      showConfirmButton:
        false
    });


    // =====================================
    // CLOSE EDIT MODAL
    // =====================================
    handleClose();


  } catch (error) {

    console.error(
      "Remove PO Item Error:",
      error
    );

    Swal.fire(
      "Error",
      error?.response?.data?.message ||
      error?.message ||
      "Failed to remove item(s) from Purchase Order.",
      "error"
    );
  }
};

  return (
    <Modal show={show} onHide={handleClose} size="xl" fullscreen>
      <Modal.Header closeButton>
        <Modal.Title>
          Edit Purchase Order - PO: {item?.poNumber || "-"} / Requisition: {item?.requisitionNo?.requisitionNo || "-"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Delivery Address */}
        <h3 className="text-center">Delivery Address</h3>
        <div className="row mb-3">
          {["street", "city", "state", "pincode", "country"].map((f, idx) => (
            <div className="col-md-4 mb-2" key={idx}>
              <Form.Label>{f.charAt(0).toUpperCase() + f.slice(1)}</Form.Label>
              <Form.Control
                type="text"
                value={formData.deliveryAddress?.[f] || ""}
                placeholder={f}
                readOnly
              />
            </div>
          ))}
        </div>

        {/* Requisition Number & Supplier */}
        <div className="row mb-3">
          <div className="col-md-6 mb-2">
            <Form.Label>Requisition Number</Form.Label>
            <Form.Control type="text" value={formData.requisitionNo || ""} readOnly />
          </div>
          <div className="col-md-6 mb-2">
            <Form.Label>Select Supplier</Form.Label>
            <Form.Select
              className="pb-3 pt-3"
              value={formData.supplier}
              onChange={(e) => setFormData(prev => ({ ...prev, supplier: e.target.value }))}
            >
              <option value="">-- Select Supplier --</option>
              {suppliers.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
            </Form.Select>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-12 mb-2">
            <Form.Label>Subject</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter subject"
              value={formData.subject || ""}
              onChange={(e) =>
                setFormData(prev => ({
                  ...prev,
                  subject: e.target.value
                }))
              }
            />
          </div>
        </div>
        {/* term and conndition  */}
        <div className="row mb-3">
          <div className="col-md-12 mb-2">
            <Form.Label>Terms & Conditions</Form.Label>
            <Form.Control
              as="textarea"
              rows={6}
              value={(formData.termCondition || []).join("\n")}
              onChange={(e) =>
                setFormData(prev => ({
                  ...prev,
                  termCondition: e.target.value
                    .split("\n")
                    .filter(line => line.trim() !== "")
                }))
              }
            />

          </div>


        </div>

        {/* Items Table */}
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>#</th>

              {/* ✅ NEW */}
              <th className="text-center">
                Remove
              </th>

              <th>Part No</th>
              <th>Description</th>
              <th>Approved Qty (PO Unit)</th>
              <th>Rate</th>
              <th>CGST %</th>
              <th>SGST %</th>
              <th>IGST %</th>
              <th>Amount</th>
            </tr>
          </thead>

          <tbody>
            {formData.items.map((it, idx) => {

              const isRemoved =
                it.removeThisItem === true;

              return (
                <tr
                  key={it.id}
                  style={{
                    opacity: isRemoved ? 0.6 : 1,
                    backgroundColor:
                      isRemoved
                        ? "#f8d7da"
                        : ""
                  }}
                >
                  {/* SERIAL */}
                  <td>
                    {idx + 1}
                  </td>

                  {/* ============================= */}
                  {/* ✅ REMOVE CHECKBOX */}
                  {/* ============================= */}
                  <td className="text-center">

                    {formData.items.length > 1 &&
                      (
                        isRemoved ||
                        remainingItemCount > 1
                      ) && (

                        <Form.Check
                          type="checkbox"
                          checked={isRemoved}
                          onChange={(e) =>
                            handleRemoveItemToggle(
                              idx,
                              e.target.checked
                            )
                          }
                        />

                      )}

                  </td>

                  {/* PART NO */}
                  <td>
                    {it.partNo}
                  </td>

                  {/* DESCRIPTION */}
                  <td>
                    <Form.Control
                      type="text"
                      value={it.description}
                      disabled={isRemoved}
                      onChange={(e) =>
                        handleInputChange(
                          idx,
                          "description",
                          e.target.value
                        )
                      }
                    />
                  </td>

                  {/* ============================= */}
                  {/* APPROVED QTY */}
                  {/* ============================= */}
                  <td>
                    <div className="d-flex align-items-center gap-2">

                      <Form.Control
                        type="number"

                        // ✅ SHOW 0 IF REMOVE SELECTED
                        value={
                          isRemoved
                            ? 0
                            : it.approveQty
                        }

                        max={it.originalApproveQty}
                        min={0}

                        disabled={isRemoved}

                        onChange={(e) =>
                          handleInputChange(
                            idx,
                            "approveQty",
                            e.target.value
                          )
                        }
                      />

                      <span className="fw-bold">
                        {it.unit}
                      </span>

                      <Button
                        variant="success"
                        size="sm"

                        // ✅ DON'T ALLOW QTY UPDATE
                        // WHEN ITEM IS SELECTED FOR REMOVE
                        disabled={isRemoved}

                        onClick={() =>
                          handleQtyUpdate(it)
                        }
                      >
                        ✓
                      </Button>

                    </div>
                  </td>

                  {/* ============================= */}
                  {/* RATE */}
                  {/* ============================= */}
                  <td>
                    <Form.Control
                      type="number"

                      value={
                        isRemoved
                          ? 0
                          : it.rate
                      }

                      onWheel={(e) =>
                        e.target.blur()
                      }

                      onChange={(e) =>
                        handleInputChange(
                          idx,
                          "rate",
                          e.target.value
                        )
                      }

                      disabled={isRemoved}

                      readOnly={
                        !isRemoved && isFOC
                      }
                    />
                  </td>

                  {/* ============================= */}
                  {/* CGST */}
                  {/* ============================= */}
                  <td>
                    <Form.Control
                      type="number"

                      value={
                        isRemoved
                          ? 0
                          : it.cgst
                      }

                      onWheel={(e) =>
                        e.target.blur()
                      }

                      onChange={(e) =>
                        handleInputChange(
                          idx,
                          "cgst",
                          e.target.value
                        )
                      }

                      disabled={isRemoved}

                      readOnly={
                        !isRemoved && isFOC
                      }
                    />
                  </td>

                  {/* ============================= */}
                  {/* SGST */}
                  {/* ============================= */}
                  <td>
                    <Form.Control
                      type="number"

                      value={
                        isRemoved
                          ? 0
                          : it.sgst
                      }

                      onWheel={(e) =>
                        e.target.blur()
                      }

                      onChange={(e) =>
                        handleInputChange(
                          idx,
                          "sgst",
                          e.target.value
                        )
                      }

                      disabled={isRemoved}

                      readOnly={
                        !isRemoved && isFOC
                      }
                    />
                  </td>

                  {/* ============================= */}
                  {/* IGST */}
                  {/* ============================= */}
                  <td>
                    <Form.Control
                      type="number"

                      value={
                        isRemoved
                          ? 0
                          : it.igst
                      }

                      onWheel={(e) =>
                        e.target.blur()
                      }

                      onChange={(e) =>
                        handleInputChange(
                          idx,
                          "igst",
                          e.target.value
                        )
                      }

                      disabled={isRemoved}

                      readOnly={
                        !isRemoved && isFOC
                      }
                    />
                  </td>

                  {/* ============================= */}
                  {/* AMOUNT */}
                  {/* ============================= */}
                  <td>
                    ₹{
                      isRemoved
                        ? "0.00"
                        : (
                          (parseFloat(it.rate) || 0) *
                          (parseFloat(it.approveQty) || 0)
                        ).toFixed(2)
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>



        {/* Totals */}
        {formData.items.length > 0 && (
          <div className="mt-3 text-end fw-bold">
            {(() => {
              const t = calculateTotals();
              return (
                <>
                  Base: ₹{t.base} | CGST: ₹{t.cgst} | SGST: ₹{t.sgst} | IGST: ₹{t.igst}
                  <br />
                  <span className="text-primary">Grand Total: ₹{t.total}</span>
                </>
              );
            })()}
          </div>
        )}

        <div className="border rounded p-3 mt-4 bg-light">

          <Form.Check
            type="checkbox"
            label="Advance Payment"
            checked={isAdvanceRental}
            onChange={(e) => {
              const checked = e.target.checked;

              setIsAdvanceRental(checked);

              if (!checked) {
                setAdvanceRentalAmount("");
                setAdvanceRentalPercent("");
                setAdvanceRentalError(false);
              }
            }}
          />

          {isAdvanceRental && (
            <div className="row mt-3">

              <div className="col-md-4">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  value={advanceRentalAmount}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    handleAdvanceAmountChange(e.target.value)
                  }
                  isInvalid={advanceRentalError}
                />
              </div>

              <div className="col-md-4">
                <Form.Label>%</Form.Label>
                <Form.Control
                  type="number"
                  value={advanceRentalPercent}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    handleAdvancePercentChange(e.target.value)
                  }
                  isInvalid={advanceRentalError}
                />
              </div>

              <div className="col-md-4 d-flex align-items-end">
                <strong>
                  Based On Total ₹{calculateTotals().total}
                </strong>
              </div>

            </div>
          )}

        </div>
      </Modal.Body>

      <Modal.Footer>

        {/* ============================= */}
        {/* CLOSE - ALWAYS VISIBLE */}
        {/* ============================= */}
        <Button
          variant="secondary"
          onClick={handleClose}
        >
          Close
        </Button>


        {/* ============================= */}
        {/* REMOVE MODE */}
        {/* Show only when item selected */}
        {/* ============================= */}
        {hasSelectedRemoveItems && (
          <Button
            variant="danger"
            type="button"
            onClick={handleRemoveSelectedItems}
          >
            Remove Selected ({selectedRemoveCount})
          </Button>
        )}


        {/* ============================= */}
        {/* NORMAL UPDATE MODE */}
        {/* Hide when removal selected */}
        {/* ============================= */}
        {!hasSelectedRemoveItems && (
          <Button
            variant="primary"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        )}

      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(POEditModal);
